import TranslatableRichTextField from './Container';

export default TranslatableRichTextField;
